export default __webpack_public_path__ + "static/media/btn_kakao.9a8729f5.svg";